var isLocalizationLoaded = false;
var isLocalizationLoading = false;

var localizationData = null;
var localizationLoadPromise = null;

window.localization =
{
    clear: async function ()
    {
        localStorage.removeItem("localization.lastmodified");
        localStorage.removeItem("localization.data");

        isLocalizationLoaded = false;

        localization.load();
    },
    get: async function (key)
    {
        if (!isLocalizationLoaded)
            await localization.load();

        if (!localizationData)
            return key;

        return localizationData[key] || key;
    },
    load: async function ()
    {
        if (isLocalizationLoading)
            return localizationLoadPromise;

        isLocalizationLoading = true;

        localizationLoadPromise = new Promise(async (resolve, reject) =>
        {
            var cacheLastModified = localStorage.getItem("localization.lastmodified");
            var cacheData = localStorage.getItem("localization.data");

            var headers = new Headers();

            if (cacheLastModified && cacheData)
                headers.append("If-Modified-Since", cacheLastModified);

            var response = null;

            var data = null;

            try
            {
                response = await fetch(`${document.baseURI}api/localization`,
                {
                    method: "GET",
                    headers: headers
                });

                if (response.status == 304)
                {
                    localizationData = JSON.parse(cacheData);

                    isLocalizationLoaded = true;
                    isLocalizationLoading = false;

                    resolve();

                    return;
                }

                if (response.status != 200)
                    throw await response.text();

                data = await response.json();
            }
            catch (error)
            {
                console.log("Failed to load localization: " + error);

                isLocalizationLoaded = true;
                isLocalizationLoading = false;

                reject(error);

                return;
            }

            localizationData = data;

            localStorage.setItem("localization.data", JSON.stringify(data));
            localStorage.setItem("localization.lastmodified", response.headers.get("Last-Modified"));

            isLocalizationLoaded = true;
            isLocalizationLoading = false;

            resolve();
        });

        return localizationLoadPromise;
    },
};